
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-amber-50 via-orange-50 to-teal-50 text-gray-800 py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/f42e20f23ee10135ebb8bc87eaeeb99a.png"
                alt="Focaccia Restaurant"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-gray-700 leading-relaxed text-base">
              مطعم فوكاتشيا - تجربة طعام فندقية راقية على مدار الساعة، نقدم بوفيه فطور مفتوح يوميًا بالإضافة إلى قوائم غداء وعشاء متنوعة والكافي مفتوح ٢٤ ساعة
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6 text-teal-700" style={{ fontFamily: 'Cairo, sans-serif' }}>
              روابط سريعة
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-700 hover:text-teal-600 transition-colors text-base cursor-pointer"
                >
                  الرئيسية
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-700 hover:text-teal-600 transition-colors text-base cursor-pointer"
                >
                  من نحن
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-us')}
                  className="text-gray-700 hover:text-teal-600 transition-colors text-base cursor-pointer"
                >
                  لماذا نحن
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('menu')}
                  className="text-gray-700 hover:text-teal-600 transition-colors text-base cursor-pointer"
                >
                  قائمة الفطور
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-700 hover:text-teal-600 transition-colors text-base cursor-pointer"
                >
                  معرض الصور
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('location')}
                  className="text-gray-700 hover:text-teal-600 transition-colors text-base cursor-pointer"
                >
                  الموقع
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('reservation')}
                  className="text-gray-700 hover:text-teal-600 transition-colors text-base cursor-pointer"
                >
                  احجز طاولتك
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6 text-teal-700" style={{ fontFamily: 'Cairo, sans-serif' }}>
              تواصل معنا
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-time-line text-2xl text-teal-600 mt-1"></i>
                <div>
                  <p className="font-semibold text-base text-gray-800">ساعات العمل</p>
                  <p className="text-gray-700 text-sm">بوفيه الفطور: 6:30 ص - 11:00 ص</p>
                  <p className="text-gray-700 text-sm">الكافي والمطعم: ٢٤ ساعة يوميًا</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-2xl text-teal-600 mt-1"></i>
                <div>
                  <p className="font-semibold text-base text-gray-800">الموقع</p>
                  <p className="text-gray-700 text-sm">الطابق الأرضي - الفندق</p>
                  <p className="text-gray-700 text-sm text-orange-600">ملاحظة: لا تتوفر خدمة صف السيارات</p>
                </div>
              </div>
            </div>

            <div className="flex gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-200 pt-8 text-center">
          <p className="text-gray-600 text-sm">
            © 2024 Focaccia Restaurant. جميع الحقوق محفوظة | 
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-teal-600 hover:text-teal-700 transition-colors mr-2 cursor-pointer"
            >
              Powered by CSIT
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
